import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Category } from "../model/Category";
import {
  getCategory,
  insertCategory,
  updateCategory,
} from "../service/CategoryService";
import { uploadFile } from "../config/firebaseConfig";

const emptyUser: Category = {
  uid: "",
  name: "",
  imageUrl: "",
};

export function useCategoryEditor(id: string | undefined) {
  const [category, setCategory] = useState<Category>();
  const [errors, setErrors] = useState({
    name: false,
    imageFile: false,
  });
  const navigate = useNavigate();

  const [showSnackbar, setShowSnackbar] = useState(false);
  const categoryIsValid = (errors: any) => {
    return !Object.values(errors).some((error) => error);
  };
  const validateField = (name: string, value: string) => {
    setErrors({
      ...errors,
      [name]: value.trim() === "",
    });
  };
  const handleSave = async () => {
    setShowSnackbar(true);
    const newErrors = {
      name: category?.name.trim() === "",
      imageFile: !(
        (category?.imageFile !== null && category?.imageFile !== undefined) ||
        (category?.imageUrl !== undefined && category.imageUrl !== "")
      ),
    };
    setErrors(newErrors);
    if (categoryIsValid(newErrors)) {
      if (category?.uid) {
        const url = await uploadFile(
          category.imageFile!,
          category.uid,
          "categories/",
        );
        await updateCategory({
          ...category,
          imageUrl: url ? url : category.imageUrl,
        });
      } else if (category) {
        const newId = await insertCategory(category);
        if (newId) {
          const url = await uploadFile(
            category.imageFile!,
            newId,
            "categories/",
          );
          await updateCategory({
            ...category,
            imageUrl: url ? url : category?.imageUrl,
            uid: newId,
          }).then(() => {
            navigate(`/category/edit/${newId}`);
          });
        }
        setShowSnackbar(true);
      }
    }
  };

  useEffect(() => {
    if (id) {
      getCategory(id).then((category) => {
        if (category !== null) {
          setCategory(category);
        } else {
          navigate("/category");
        }
      });
    } else {
      setCategory(emptyUser);
    }
    // eslint-disable-next-line
  }, [id]);
  return {
    handleSave,
    validateField,
    showSnackbar,
    errors,
    setShowSnackbar,
    category,
    setCategory,
    categoryIsValid,
  };
}
